/**
 * @see https://gist.github.com/RienNeVaPlus/024de3431ae95546d60f2acce128a7e2
 */

/**
 *
 */
const DATE_DIFF_DEF = Object.freeze({
  millennium: 31536000000000,
  century: 3153600000000,
  decade: 315360000000,
  year: 31536000000,
  quarter: 7776000000,
  month: 2592000000,
  week: 604800000,
  day: 86400000,
  hour: 3600000,
  minute: 60000,
  second: 1000,
  millisecond: 1,
});

export type DateDiffKey = keyof typeof DATE_DIFF_DEF;
export type DateDifference = {
  [key in DateDiffKey]: number;
};

const DATE_DIFF_KEYS = Object.freeze(
  Object.keys(DATE_DIFF_DEF),
) as DateDiffKey[];

/**
 * ☃ dateDiff "Snowman Carl" (http://stackoverflow.com/questions/13903897)
 * Returns a detail object about the difference between two dates
 *
 * When providing custom units, provide them in descending order (eg week,day,hour; not hour,day,week)
 */
export function dateDiff(
  dateStartInput: Date | string,
  dateEndInput: Date | string = new Date(),
  units: DateDiffKey[] = DATE_DIFF_KEYS,
): DateDifference {
  const dateStart =
    dateStartInput instanceof Date ? dateStartInput : new Date(dateStartInput);
  const dateEnd =
    dateEndInput instanceof Date ? dateEndInput : new Date(dateEndInput);

  let delta: number = Math.abs(dateStart.getTime() - dateEnd.getTime());

  return units.reduce<DateDifference>(
    (res: DateDifference, key: DateDiffKey) => {
      res[key] = Math.floor(delta / DATE_DIFF_DEF[key]);
      delta -= res[key] * DATE_DIFF_DEF[key];
      return res;
    },
    {} as DateDifference,
  );
}
